import { Space, Typography, Tooltip, Spin } from 'antd';
import { DollarOutlined } from '@ant-design/icons';
import { useExchangeRates } from '@hooks/useInventory';

// GET /exchange-rates/all повертає об'єкт { "USD": 44.618, "EUR": 51.5231, ... }
const MD_SHOWN_CURRENCIES = ['USD', 'EUR'] as const;

export default function ExchangeRateWidget() {
  const { data: mdRates, isLoading: mdIsLoading } = useExchangeRates();

  if (mdIsLoading) {
    return <Spin size="small" />;
  }

  const mdShown = MD_SHOWN_CURRENCIES.flatMap((mdCode) => {
    const mdRate = mdRates?.[mdCode];
    return typeof mdRate === 'number' ? [{ code: mdCode, rate: mdRate }] : [];
  });

  if (mdShown.length === 0) {
    return null;
  }

  return (
    <Tooltip title="Курс НБУ на сьогодні">
      <Space
        size={12}
        style={{
          padding: '0 12px',
          cursor: 'default',
          userSelect: 'none',
        }}
      >
        <DollarOutlined style={{ color: '#8c8c8c' }} />
        {mdShown.map((mdItem) => (
          <Typography.Text key={mdItem.code} type="secondary" style={{ fontSize: 13 }}>
            {mdItem.code} {mdItem.rate.toFixed(2)}
          </Typography.Text>
        ))}
      </Space>
    </Tooltip>
  );
}
